<template>
  <div>
    <v-tabs v-model="tab" background-color="transparent" class="mb-2">
      <v-tab>Editor</v-tab>
      <v-tab>Preview</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <RichTextEditor
          maxheight="tall"
          :value="html"
          :allowImages="true"
          :showImageHint="false"
          @input="onInput"
        />
        <div class="caption grey--text mt-1">
          Tip: use the horizontal line for a <strong>page break</strong>, the columns button for a
          <strong>2-column layout</strong>, and click images to resize (100% / 50% / 33% / 25%).
        </div>
      </v-tab-item>
      <v-tab-item>
        <ProgramPagePreview
          v-if="showPreview && tab === 1"
          :key="`preview-${html.length}-${title}`"
          class="mt-2"
          :title="title"
          :type="type"
          :content="value"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ProgramPagePreview from "./ProgramPagePreview";
import { normalizePageContent } from "../utils";

export default {
  components: {
    ProgramPagePreview,
  },
  props: {
    type: {
      type: String,
      default: "excursions_visites",
    },
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    showPreview: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    html() {
      return normalizePageContent(this.type, this.value).html || "";
    },
  },
  methods: {
    onInput(html) {
      this.$emit("input", { html: html == null ? "" : String(html) });
    },
  },
};
</script>
